module.exports = __webpack_public_path__ + "img/optaline.515aa579.jpeg";